import * as z from "zod";
import { RoutingRuleConfigSchema } from "./routing-rule-config";

/**
 * Per-integration configuration for Redo-managed returns with refulfillment,
 * applied only for merchants on managed returns. Grouped by domain (order
 * routing, inventory). Only the rule-type pipeline
 * ({@link RoutingRuleConfigSchema}) is shared across providers.
 */
const CommentsoldManagedReturnsSchema_ = z.object({
  enabled: z.boolean().default(false),
  order: z
    .object({
      routingRules: z.array(RoutingRuleConfigSchema).nullish(),
      allowSplitShipments: z.boolean().default(false),
      markAsPrinted: z.boolean().default(false),
    })
    .nullish(),
  inventory: z
    .object({ sharedInventory: z.boolean().default(false) })
    .nullish(),
});
export const CommentsoldManagedReturnsSchema: z.ZodType<CommentsoldManagedReturns> =
  CommentsoldManagedReturnsSchema_;

export interface CommentsoldManagedReturns extends z.infer<
  typeof CommentsoldManagedReturnsSchema_
> {}
